(function () {
    'use strict';

    angular
        .module('ib-booking-name')
        .service('BookingNameService', BookingNameService);

    BookingNameService.$inject = ['$uibModal', 'CheckinRouterConstants'];
    function BookingNameService($uibModal, CheckinRouterConstants) {

        /**
         * @function
         * @name check
         * @desc opens a modal to ask the passenger
         */
        this.checkName = function (surname, flowId) {
            var modalInstance = $uibModal.open({
                //   animation: $scope.animationsEnabled,
                controller: 'BookingNameModalController',
                templateUrl: CheckinRouterConstants.templatesRoute + 'ibcose.modal-name.html',
                controllerAs: 'modalCtrl',
                size: 'md',
                ackdrop: 'static',
                keyboard: false,
                windowClass: 'ib-modals ib-modals--md',
                resolve: {
                    surname: function() {
                        return surname;
                    },
                    flowId: function() {
                        return flowId;
                    }
                }
            });
        }

    }
})();
